import { Injectable } from "@angular/core";

import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/Operators";
import { Observable, throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { AppConfig } from "../../app.config";
import {
  BasicEmployeeDetails,
  EmpHistoryDetails,
  HistoryDetails,
} from "../models/basicemployeedetails.model";
import { Designation } from "../models/Designation";
import { HREmployeeDetails } from "../models/hremployeecommunicationdetails.model";
import { HrEmployeeFinanceDetails } from "../models/hrEmpFinanceDtls";
import { HrEmployeePassportVisaInfo } from "../models/hrEmpPassportVisaDtls";
import {
  EmpPreviousEmploymentDetails,
  HrEmpPreviousEmploymentDetails,
} from "../models/hrEmpPrevEmpDtls";
import { HrEmpProfessionalReferenceDetails } from "../models/hrEmpReferenceDtls";
import { hrEmpPersonalDetails } from "../models/hrEmpPersonalDetails";
import { Awards } from "../models/Awards";
import { HrEmpEducationInfo } from "../models/HrEmpEducationInfo";
import { EmpInsurance } from "../models/EmpInsurance";
import { MasterData } from "../models/MasterData";
import { MasterDataDetails } from "../models/MasterDataDetails";
import { WinHRPagesUserMapping } from "../models/WinHRPagesUserMapping ";
import { InsurancePremiumDetails } from "../models/InsurancePremiumDetails";
import { SumAssuredDetails } from "../models/InsuranceSumAssuredDtls";
import { ProfileVerificationStatus } from "../models/ProfileVerificationStatus";
import { Offboarding } from "../models/Offboarding";
import { OffboardingCheckListResultClass } from "../models/OffboardingCheckListResultClass";
import { OffboardingSettings } from "../models/OffboardingSettings";
import { EmpFBAnswers } from "../models/EmpFBAnswers";
import { Department } from "../models/Department";
import { Cadre } from "../models/Cadre";
import { VisaTypes } from "../models/VisaTypes";
import { EmployeeModel } from "../models/employee.model";
import { ExitInterviews } from "../models/ExitInterviews";
import { EmployeeBonus } from "../models/OnboardingHRDetail";
import { CreateExpertise } from "../models/AdditionalSkills";
import { ExitReasonDetails } from "../models/ExitReasonDetails";
import { switchMap, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: "root",
})
export class EmployeeService {
  constructor(private http: HttpClient, private config: AppConfig) { }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }
  getAllEmployees(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllEmployees")
      .pipe(catchError(this.handleError));
  }
  getAllActiveEmployees(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllActiveEmployees")
      .pipe(catchError(this.handleError));
  }
  getAllContacts(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllContacts")
      .pipe(catchError(this.handleError));
  }
  getAllFeedbacks(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllFeedbacktypes")
      .pipe(catchError(this.handleError));
  }
  getAllExcelEmployees(employees: BasicEmployeeDetails[]): Observable<any> {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/GetAllExcelEmployees",
        employees
      )
      .pipe(catchError(this.handleError));
  }
  getAllActiveSubConEmployees(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllActiveSubConEmployees")
      .pipe(catchError(this.handleError));
  }
  getReasons(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetReasons")
      .pipe(catchError(this.handleError));
  }
  getAllActiveFTEEmployees(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllActiveFTEEmployees")
      .pipe(catchError(this.handleError));
  }
  getUserRoles(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetUserRoles")
      .pipe(catchError(this.handleError));
  }
  getTabs(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetTabsLists")
      .pipe(catchError(this.handleError));
  }
  getBasicEmployeeById(empCode: number): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetBasicEmployeeById?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getEmployeeById(empCode: number): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetEmployeeById?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getDateofExitByEmpCode(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetDateofExitByEmpCode?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getEmployeeHistory(empCode: number): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmployeeHistoryById?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeeDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmployeeDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingHistoryApi(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingHistory?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getEmployeePersonalDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmployeePersonalDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeeFamilyDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmployeeFamilyDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeeEducationalDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmpEducationDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeePreviousEmploymentDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHRPrevEmploymentDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeeReferenceDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmpReferences?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeePassportVisaDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetPassportVisaInfo?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeeFinanceDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmpolyeeFinanceDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getOffboardingDetails(empCode: number): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getEmployeeDetailsByGroupId(groupId: string) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetBasicEmployeeByGroupId?groupId=" +
        groupId
      )
      .pipe(catchError(this.handleError));
  }

  getHREmployeeGroupDetails(groupId: string) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetHREmployeeGroupDetails?groupId=" +
        groupId
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingDetailsById(offboardingID: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingDetailsById?ID=" +
        offboardingID
      )
      .pipe(catchError(this.handleError));
  }

  getEmployeeName(empcode) {
    return this.http
      .get(
        this.config.apiUrl + "HREmployeeApi/getEmployeeName?empcode=" + empcode
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingQueueDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingQueueDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingInwardDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingInwardDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getAllOffboardingDetails() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllOffboaardingDetails")
      .pipe(catchError(this.handleError));
  }

  getAllExcelOffboardingDetails(offboarding: Offboarding[]): Observable<any> {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/GetAllExcelOffboaardingDetails ",
        offboarding
      )
      .pipe(catchError(this.handleError));
  }

  getEmployeeAwardDetails(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetEmployeeAwardDetails?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmpListByPMCode(pmCode: number) {
    return this.http
      .get(
        this.config.apiUrl + "HREmployeeApi/GetEmpListByPMCode?pmCode=" + pmCode
      )
      .pipe(catchError(this.handleError));
  }
  getAddPermissionOffBoardingList(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetAddPermissionOffBoardingList?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingHRListAddPermission(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingHRListAddPermission?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingFinanceListAddPermission(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingFinanceListAddPermission?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getOffboardingCompletedDeptListAddPermission(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingCompletedDeptListAddPermission?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getDepartmentsApi() {
    return this.http
      .get(this.config.apiUrl + "masterdataApi/GetDepartments")
      .pipe(catchError(this.handleError));
  }

  getPMByCode(empCode: number) {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetPMByCode?empCode=" + empCode)
      .pipe(catchError(this.handleError));
  }

  getEmpListByPMCodeAfterHR(pmCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetEmpListByPMCodeAfterHR?pmCode=" +
        pmCode
      )
      .pipe(catchError(this.handleError));
  }
  getAllPeopleManagers(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllPeopleManagers")
      .pipe(catchError(this.handleError));
  }

  GetProfileVerificationStatus(id: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetProfileVerificationStatus?empId=" +
        id
      )
      .pipe(
        catchError(this.handleError),
        shareReplay(1)
      );
  }

  SaveHrEmployeeDetails(emp: BasicEmployeeDetails) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveBasicEmployee", emp)
      .pipe(catchError(this.handleError));
  }
  addDesignation(desg: Designation) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveDesignation", desg)
      .pipe(catchError(this.handleError));
  }
  saveEmpDetails(emp: HREmployeeDetails) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveEmployeeDetails", emp)
      .pipe(catchError(this.handleError));
  }
  SaveEmpEducationDetails(emp: HrEmpEducationInfo) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveEducationalDetails", emp)
      .pipe(catchError(this.handleError));
  }
  DeleteFileinMultipleFiles(Id: number) {
    return this.http
      .delete(
        this.config.apiUrl + "HREmployeeApi/DeleteFileinMultipleFiles?Id=" + Id
      )
      .pipe(catchError(this.handleError));
  }
  SavePassportVisaDetails(emp: HrEmployeePassportVisaInfo) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SavePassportVisaDetails", emp)
      .pipe(catchError(this.handleError));
  }
  SaveFinanceDetails(emp: HrEmployeeFinanceDetails) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveFinanceDetails", emp)
      .pipe(catchError(this.handleError));
  }
  SaveEmployeePermissions(emp: WinHRPagesUserMapping[]) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveEmployeePermissions", emp)
      .pipe(catchError(this.handleError));
  }
  SaveEmployeeAwards(awd: Awards) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveEmployeeAwards", awd)
      .pipe(catchError(this.handleError));
  }

  SaveEmployeeHiringDetails(hrHiringDetails: any) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveEmployeeHiringDetails",
        hrHiringDetails
      )
      .pipe(catchError(this.handleError));
  }

  SaveOffboardingDetails(offboarding: Offboarding) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveOffboardingDetails",
        offboarding
      )
      .pipe(catchError(this.handleError));
  }

  UploadExitFile(offboarding: Offboarding) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/UpdateResignationDoc",
        offboarding
      )
      .pipe(catchError(this.handleError));
  }

  DeleteExitFile(offboarding: Offboarding) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/DeleteResignationDoc",
        offboarding
      )
      .pipe(catchError(this.handleError));
  }

  SaveEmployeeHistory(emp: EmpHistoryDetails) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveHrEmployeeHistory", emp)
      .pipe(catchError(this.handleError));
  }

  InitiateOffboardingDetails(offboarding: Offboarding) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/InitiateOffboarding",
        offboarding
      )
      .pipe(catchError(this.handleError));
  }
  SubmitFeedbackForm(offboarding: Offboarding) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SubmitFeedbackForm",
        offboarding
      )
      .pipe(catchError(this.handleError));
  }
  SavePrevEmploymentDetails(emp: EmpPreviousEmploymentDetails) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SavePrevEmploymentDetails", emp)
      .pipe(catchError(this.handleError));
  }
  SaveReferenceDetails(emp: HrEmpProfessionalReferenceDetails[]) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveReferenceDetails", emp)
      .pipe(catchError(this.handleError));
  }
  SaveEmpPersonalDetails(emp: hrEmpPersonalDetails) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveEmpPersonalDetails", emp)
      .pipe(catchError(this.handleError));
  }
  SaveDesignation(desg: Designation) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveDesignation", desg)
      .pipe(catchError(this.handleError));
  }
  saveallcontacts(offSet: OffboardingSettings) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveAllContacts", offSet)
      .pipe(catchError(this.handleError));
  }
  SaveMasterGroup(techgroup: MasterData) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveMasterGroup", techgroup)
      .pipe(catchError(this.handleError));
  }
  SaveExitReason(exitReason: ExitReasonDetails) {
    return this.http
      .post(
        this.config.apiUrl + "MasterDataApi/SaveExitReasonDetails",
        exitReason
      )
      .pipe(catchError(this.handleError));
  }
  SaveMasterGroupDetails(expertise: MasterDataDetails) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveMasterGroupDetails",
        expertise
      )
      .pipe(catchError(this.handleError));
  }
  SaveEmployeeInsurance(insuranceArray: EmpInsurance) {
    return this.http
      .post(
        this.config.apiUrl + "InsuranceApi/SaveEmployeeInsurance",
        insuranceArray
      )
      .pipe(catchError(this.handleError));
  }
  //SaveProfileVerificationStatus(profileVerificationStatus: ProfileVerificationStatus) {

  //  return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveProfileVerificationStatus", profileVerificationStatus).pipe(catchError(this.handleError));

  //}
  SaveProfileVerificationStatus(
    profileVerificationStatus: ProfileVerificationStatus[]
  ) {
    //console.log(this.config.apiUrl + "HREmployeeApi/SaveSubmitted", profileVerificationStatus).pipe(catchError(this.handleError));
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveProfileVerificationStatus",
        profileVerificationStatus
      )
      .pipe(catchError(this.handleError));
  }
  SaveEmpFbAnswers(answers: EmpFBAnswers[]) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveEmpFeedbackAnswers",
        answers
      )
      .pipe(catchError(this.handleError));
  }
  getInsuranceDetails(empCode: number, premiumYearId: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "InsuranceApi/GetInsuranceDetails?empCode=" +
        empCode +
        "&premiumYearId=" +
        premiumYearId
      )
      .pipe(catchError(this.handleError));
  }
  getAllEmpRelations(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllEmpRelations")
      .pipe(catchError(this.handleError));
  }
  getAllHRPages(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllHRWinHRPages")
      .pipe(catchError(this.handleError));
  }
  getEmpFbQuestions(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetEmpFBQuestions")
      .pipe(catchError(this.handleError));
  }
  getEmpFbAnswers(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetEmpFBAnswers")
      .pipe(catchError(this.handleError));
  }

  getAllUserMappings(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllHRUserMappings")
      .pipe(catchError(this.handleError));
  }
  GetHRWinHRPages(empCode): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl + "HREmployeeApi/GetHRWinHRPages?empCode=" + empCode
      )
      .pipe(catchError(this.handleError));
  }
  GetOffboardingChecklistResult(empCode): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingChecklistResult?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  GetOffboardingChecklistResultWithRadioButtons(
    empCode,
    feedbackType
  ): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingChecklistResultWithRadioButtons?empCode=" +
        empCode +
        "&feedbackType=" +
        feedbackType
      )
      .pipe(catchError(this.handleError));
  }
  GetFbAnswers(empCode): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetFeedbackAnswersResult?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  deleteEmpPermissions(empCode) {
    return this.http
      .delete(
        this.config.apiUrl +
        "HREmployeeApi/DeleteEmpPermissions?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  getInsuranceSumAssureds(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "InsuranceApi/GetInsuranceSumAssureds")
      .pipe(catchError(this.handleError));
  }
  SaveInsuranceSumAssuredValue(sumAssured: SumAssuredDetails) {
    return this.http
      .post(
        this.config.apiUrl + "InsuranceApi/SaveInsuranceSumAssuredValue",
        sumAssured
      )
      .pipe(catchError(this.handleError));
  }
  GetInsurancePermium(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "InsuranceApi/GetInsurancePermium")
      .pipe(catchError(this.handleError));
  }
  GetEmployeesInsuranceDetails(premiumYearId): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "InsuranceApi/GetEmployeesInsuranceDetails?premiumYearId=" +
        premiumYearId
      )
      .pipe(catchError(this.handleError));
  }
  getOffboardingFeedbackTypeDescription(feedbackType, code): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetOffboardingFeedbackTypeDescription?feedbackType=" +
        feedbackType +
        "&code=" +
        code
      )
      .pipe(catchError(this.handleError));
  }
  CancelEmployeeInsurance(insuranceArray: EmpInsurance) {
    return this.http
      .post(
        this.config.apiUrl + "InsuranceApi/CancelEmployeeInsurance",
        insuranceArray
      )
      .pipe(catchError(this.handleError));
  }
  SaveOffboardingChecklist(checklistresult: OffboardingCheckListResultClass[]) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveOffboardingChecklist",
        checklistresult
      )
      .pipe(catchError(this.handleError));
  }
  SaveInsurancePremiumDetails(insPremium: InsurancePremiumDetails) {
    return this.http
      .post(
        this.config.apiUrl + "InsuranceApi/SaveInsurancePremiumDetails",
        insPremium
      )
      .pipe(catchError(this.handleError));
  }
  GetExitReasonByID(exitid) {
    return this.http
      .get(
        this.config.apiUrl + "MasterDataApi/GetExitReasonByID?exitid=" + exitid
      )
      .pipe(catchError(this.handleError));
  }
  GetExitReasons() {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetExitReasons")
      .pipe(catchError(this.handleError));
  }
  GetMasterPreviousEmpDoc() {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetMasterPreviousEmpDoc")
      .pipe(catchError(this.handleError));
  }
  GetFeedbackAccordionData(feedbackType: string, empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetFeedbackAccordionData?feedbackType=" +
        feedbackType +
        "&empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  GetEmployeeQnAFeedbackAccordion(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetEmployeeQnAFeedbackAccordion?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getPeopleManagerCodeandMail(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/getPeopleManagerCodeandMail?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getActivePeopleManagerByCode(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetActivePeopleManagerByCode?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getActiveProjectManagersByCode(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetActiveProjectManagersByempCode?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getOffboardingHRList(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetOffboardingHRList")
      .pipe(catchError(this.handleError));
  }
  getOffboardingFinanceList(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetOffboardingFinanceList")
      .pipe(catchError(this.handleError));
  }
  getOffboardingClearanceList(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetOffboardingClearanceList")
      .pipe(catchError(this.handleError));
  }
  getOffboardingCompletedDeptList(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetOffboardingCompletedDeptList")
      .pipe(catchError(this.handleError));
  }
  DeleteInsurancePremium(premiumYearId) {
    return this.http
      .delete(
        this.config.apiUrl +
        "InsuranceApi/DeleteInsurancePremium?premiumYearId=" +
        premiumYearId
      )
      .pipe(catchError(this.handleError));
  }
  DeleteSumAssuredValue(sumAssuredId) {
    return this.http
      .delete(
        this.config.apiUrl +
        "InsuranceApi/DeleteSumAssuredValue?sumAssuredId=" +
        sumAssuredId
      )
      .pipe(catchError(this.handleError));
  }
  SaveRecallStatus(recallOffboarding: Offboarding) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveRecallStatus",
        recallOffboarding
      )
      .pipe(catchError(this.handleError));
  }
  DeleteOffboardingSettings(contacts) {
    return this.http
      .delete(
        this.config.apiUrl +
        "HREmployeeApi/DeleteOffboardingSettings?contacts=" +
        contacts
      )
      .pipe(catchError(this.handleError));
  }
  DeleteOffboardingEmployee(EmpCode: number) {
    return this.http
      .delete(
        this.config.apiUrl +
        "HREmployeeApi/DeleteOffboardingEmployee?EmpCode=" +
        EmpCode
      )
      .pipe(catchError(this.handleError));
  }
  SendEmail(empInfo: ProfileVerificationStatus[]) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SendEMail", empInfo)
      .pipe(catchError(this.handleError));
  }
  GetAllPolicyTypes(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "InsuranceApi/GetAllPolicyTypes")
      .pipe(catchError(this.handleError));
  }
  SaveDepartment(dept: Department) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveDepartment", dept)
      .pipe(catchError(this.handleError));
  }
  addDepartment(dept: Department) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveDepartment", dept)
      .pipe(catchError(this.handleError));
  }
  SaveCadre(cadr: Cadre) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveCadre", cadr)
      .pipe(catchError(this.handleError));
  }
  addCadre(cadr: Cadre) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveCadre", cadr)
      .pipe(catchError(this.handleError));
  }

  //getEmployeeHistory(empCode: number) {
  //  return this.http.get(this.config.apiUrl + "HREmployeeApi/GetEmployeeHistoryByEmpCode?empCode=" + empCode).pipe(
  //    catchError(this.handleError)
  //  );
  //}

  getVisaCountryByEmpCode(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetVisaCountryByEmpCode?empCode=" +
        empCode
      )
      .pipe(
        catchError(this.handleError),
        shareReplay(1)
      );
  }

  getVisaTypes() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetVisaTypes")
      .pipe(catchError(this.handleError));
  }

  SaveVisaType(visa: VisaTypes) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveVisaType", visa)
      .pipe(catchError(this.handleError));
  }

  getCostCenters() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetCostCentres")
      .pipe(catchError(this.handleError));
  }

  UpdateResignationStatus(offboard) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/UpdateResignationStatus",
        offboard
      )
      .pipe(catchError(this.handleError));
  }
  getExitInterviewQuestions() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetExitInterviewQuestions")
      .pipe(catchError(this.handleError));
  }

  saveExitInterviewQuestions(exitInterviews: ExitInterviews) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveExitInterviewQuestion",
        exitInterviews
      )
      .pipe(catchError(this.handleError));
  }

  deleteExitInterviewQuestions(Id: number) {
    return this.http
      .delete(
        this.config.apiUrl +
        "HREmployeeApi/DeleteExitInterviewQuestion?Id=" +
        Id
      )
      .pipe(catchError(this.handleError));
  }
  SaveInterviewQuestionSortOrder(exitInterviews: ExitInterviews[]) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveInterviewQuestionSortOrder",
        exitInterviews
      )
      .pipe(catchError(this.handleError));
  }
  saveExitInterviewResponses(exitInterviews: ExitInterviews[]) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveEmpFeedbackComments",
        exitInterviews
      )
      .pipe(catchError(this.handleError));
  }
  sendEmployeeFeeedback(Id: number) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SendEmpFeedback?Id=" + Id, {})
      .pipe(catchError(this.handleError));
  }
  getEmpFeedbackComments(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetEmpFeedbackComments?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getEmpFeedbackHistory(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetEmpFeedbackHistory?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }
  getExitInterviewHistory(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
        "HREmployeeApi/GetExitInterviewHRComments?empCode=" +
        empCode
      )
      .pipe(catchError(this.handleError));
  }

  submitExitInterviewHRComments(exitInterviews: ExitInterviews) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SubmitExitInterviewHRComments",
        exitInterviews
      )
      .pipe(catchError(this.handleError));
  }
  getEmpBonus() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetEmpBonus")
      .pipe(catchError(this.handleError));
  }

  saveEmpBonus(bonus: EmployeeBonus) {
    return this.http
      .post(this.config.apiUrl + "HREmployeeApi/SaveEmpBonus", bonus)
      .pipe(catchError(this.handleError));
  }

  getStreams() {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetStreams")
      .pipe(catchError(this.handleError));
  }

  getPrimarySkills() {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetPrimarySkill")
      .pipe(catchError(this.handleError));
  }

  getSecondarySkills() {
    return this.http
      .get(this.config.apiUrl + "MasterDataApi/GetSecondarySkill")
      .pipe(catchError(this.handleError));
  }

  saveTechGroupDetails(details: CreateExpertise) {
    return this.http
      .post(this.config.apiUrl + "MasterDataApi/SaveTechGroupDetails", details)
      .pipe(catchError(this.handleError));
  }

  getLeaveType() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetLeaveType")
      .pipe(catchError(this.handleError));
  }

  getDownloadURL(url): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/getDownloadURl?documentPath=" + url)
      .pipe(catchError(this.handleError));
  }

  getEmployeeBasicDetails() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllEmployeeDropdown")
      .pipe(catchError(this.handleError));
  }
  getActiveEmployeeBasicDetails() {
    return this.http
      .get(this.config.apiUrl + "HREmployeeApi/GetAllActiveEmployeeDropDown")
      .pipe(catchError(this.handleError));
  }
}
